import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { lodestarColors, ursaColors } from "@smartsheet/design-tokens";
import { themed } from "@smartsheet/sds-theme-internal";
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import React, { forwardRef } from "react";
import { sizes } from "../../../constants/spacing";

// eslint-disable-next-line @typescript-eslint/no-empty-interface

export var menuSeparatorTheme = themed({
  color: {
    "lodestar-light": lodestarColors.neutralLight10,
    "ursa-light": ursaColors.neutral60
  },
  height: {
    "lodestar-light": "2px",
    "ursa-light": "1px"
  },
  gap: {
    // 11 * 2 + 2 = 24px total
    "lodestar-light": "11px",
    // 12 * 2 + 1 = 25px total and that's fine per UX.
    "ursa-light": "12px"
  },
  borderRadius: {
    "lodestar-light": "0px",
    "ursa-light": "3px"
  }
});
var StyledMenuSeparator = styled("hr")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n    min-height: ", ";\n    background-color: ", ";\n    margin: ", " ", "px;\n    padding: 0;\n    border: none;\n    border-radius: ", ";\n"])), function (_ref) {
  var themMode = _ref.themMode;
  return menuSeparatorTheme.height(themMode);
}, function (_ref2) {
  var themMode = _ref2.themMode;
  return menuSeparatorTheme.color(themMode);
}, function (_ref3) {
  var themMode = _ref3.themMode;
  return menuSeparatorTheme.gap(themMode);
}, sizes.medium, function (_ref4) {
  var themMode = _ref4.themMode;
  return menuSeparatorTheme.borderRadius(themMode);
});

/**
 * https://www.w3.org/TR/wai-aria-1.2/#separator
 */
export var MenuSeparator = /*#__PURE__*/forwardRef(function (props, ref) {
  var themeKey = useCombinedThemeMode();
  return /*#__PURE__*/React.createElement(StyledMenuSeparator, _extends({}, props, {
    ref: ref,
    role: "separator",
    themMode: themeKey
  }));
});
MenuSeparator.displayName = "MenuSeparator";
//# sourceMappingURL=MenuSeparator.js.map